import { io } from "socket.io-client";


export const socket = io.connect('https://app.digitalwellnessnurse.com', { //https://app.digitalwellnessnurse.com http://localhost:4001
    path: "/broker/socket.io",
    transports: ["websocket"],
    reconnection: true,
    reconnectionDelay: 500,
    autoConnect: false,
 });
